import { render, staticRenderFns } from "./WatchBest.vue?vue&type=template&id=3b78683e"
import script from "./WatchBest.vue?vue&type=script&lang=js"
export * from "./WatchBest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports